import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
    card: {
        '& .card': {
            marginTop: 0
        },
        position: 'relative'
    }
}))